<template>
  <app-modal modal-id="cost-modal"
             modal-size="large"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_cost") : $t("add_cost") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/costs`">
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("cost_price") }}</label>
            </div>
            <div class="col-sm-9">
                <app-input
                  type="number"
                  :placeholder="$t('enter_price')"
                  name="price"
                  v-model="formData.price"
                  :required="true"
                  :error-message="$errorMessage(errors, 'price')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("cost_group") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="search-select"
                  list-value-field="name"
                  :list="costTypeList"
                  :placeholder="$t('choose_cost_group')"
                  v-model="formData.cost_type_id"
                  :required="true"
                  :error-message="$errorMessage(errors, 'cost_type_id')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("cost_status") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input type="radio"
												   list-value-field="name"
												   :list="statusList"
												   v-model="formData.status_id"
                                                   @change="changeStatus"
												   :error-message="$errorMessage(errors, 'status_id')"/>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="status == 2">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("cost_person_owner") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="search-select"
                  list-value-field="full_name"
                  :placeholder="$t('enter_cost_person_owner')"
                  :list="ownerList"
                  v-model="formData.person_id"
              />
            </div>
          </div>
        </div>
        <div class="form-group" v-else-if="status == 1">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("cost_person") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="search-select"
                  list-value-field="name"
                  :placeholder="$t('enter_cost_person')"
                  :list="PersonPodrList"
                  v-model="formData.person_id"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <label class="col-sm-3 mb-0 d-flex align-items-center">{{ $t("cost_due_date") }}</label>
            <div class="col-sm-9">
                <app-input
                      type="date"
                      :popover-position="'bottom-start'"
                      :placeholder="$t('start_date')"
                      :required="true"
                      v-model="formData.due_date"
                    />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("cost_description") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="textarea"
                  :placeholder="$t('enter_description')"
                  name="description"
                  v-model="formData.description"
                  :error-message="$errorMessage(errors, 'description')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("owner") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="select"
                  list-value-field="full_name"
                  :list="ownerList"
                  :required="true"
                  v-model="formData.owner_id"
              />
              <span class="text-danger" v-if="errors.owner_id">{{
                  errors.owner_id[0]
                }}</span>
            </div>
          </div>
        </div>
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {getAllCustomFields} from "@app/Mixins/Global/CustomFieldMixin";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  name: "CostModal",
  mixins: [FormSubmitMixin, getAllCustomFields],
  data() {
    return {
     user:{},
      dataLoaded: true,
     
      formData: {
        owner_id: user.id,
        due_date: new Date(),
        status_id: 0,
    },
    status: 0,
      addEditData: {},
      statusList:[
        {
            id: 0,
            name: this.$t('cost_status_no'),
        },
        {
            id: 1,
            name: this.$t('cost_status_person'),
        },
        {
            id: 2,
            name: this.$t('cost_status_owner'),
        },
      ],

	  
    };
  },
  computed: {
    ...mapGetters({
        ownerList: "getOwner",
        PersonPodrList: "getPersonPodr",
      costTypeList: "costType",
	 
	 
    }),

  },
  methods: {
    changeStatus(){
        if(this.formData.person_id){
            this.formData.person_id = null;
        }
        if(this.formData.status_id == 2){
            this.status = 2;
        }else{
            this.status = 1;
        }

    },

    beforeSubmit() {
      this.loading = true;
    },
    submit() {
 

      this.addEditData.description = this.formData.description;
      this.addEditData.cost_type_id = this.formData.cost_type_id;
      this.addEditData.person_id = this.formData.person_id;
      this.addEditData.status_id = this.formData.status_id;
      this.addEditData.price = this.formData.price;
      this.addEditData.due_date = moment(this.formData.due_date).format("YYYY-MM-DD");
      this.addEditData.owner_id = this.formData.owner_id;

     
      this.save(this.addEditData);
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      this.status = response.data.status_id;
      
    },

  },
  mounted() {
   
    this.$store.dispatch("getOwner");
    this.$store.dispatch("costType");
    this.$store.dispatch('getPersonPodr');
	
	
  },
};
</script>
